import React, { ReactNode } from 'react';

import cx from '../../utils/classnames';

import styles from './iconWithBadge.module.scss';
import Badge from '../Badge';

type Props = {
  className?: string;
  badgeClassName?: string;

  /** icon to show */
  icon: ReactNode;

  /** number to show on badge */
  number?: number;
};

export default function IconWithBadge(props: Props) {
  const { className, icon, number = 0, badgeClassName, ...rest } = props;

  return (
    <div className={cx(className, styles.wrapper)} {...rest}>
      {icon}
      {number > 0 && <Badge number={number} className={cx(styles.badgeWrapper, badgeClassName)} />}
    </div>
  );
}
